import { useSetRecoilState } from 'recoil';
import * as AppState from '../../AppState';

export default function useResetAllFilters() {
	const setGsPropertyListSort = useSetRecoilState(AppState.gsPropertyListSort);
	const setGsFilters = useSetRecoilState(AppState.gsFilters);

	return ([
		function doTheReset() {
			setGsFilters(currVal => ({
				...currVal,
				propertyType: 'ForSale',
				homeTypes: [],
				priceMin: 0,
				priceMax: -1,
				squareFeetMin: 0,
				squareFeetMax: -1,
				lotSizeMin: 0,
				lotSizeMax: -1,
				yearBuiltMin: 0,
				yearBuiltMax: -1,
				bedroomsMin: 0,
				bathroomsMin: 0,
				parkingSpotMin: 0,
				hasGarage: false,
				maxHoaFee: -1,
				isCapcenterListing: false,
			}));
			setGsPropertyListSort(0);
		}
	]);
}